<template>
  <div class="ws-state-file">
    <div class="ws-state-file__upload-btns">
      <WsStateFileItem
        v-if="value"
        :loading="C_files.loading"
        :percent="C_files.percent"
        :url="C_files.url"
        @remove="$_onFileRemove($event)"
        class="mb-2"
      ></WsStateFileItem>
    </div>
    <WsBtn
      v-if="!value"
      outlined
      color="textSecondary"
      @click="$_onClick()"
    >
      <v-icon size="20">mdi-paperclip</v-icon> 上傳附件
    </WsBtn>
    <input
      v-show="false"
      @change="$_onChange($event)"
      type="file"
      ref="fileInput"
      :accept="accept"
    >
  </div>
</template>

<script>
export default {
  data: () => ({
    C_files: {},
    C_value: [],
  }),
  props: {
    value: {
      type: String,
      default: "",
    },
    uploadUrl: {
      type: String,
      required: true,
    },
    accept: {
      type: String,
    }
  },
  mounted() {
    this.$_valueSet();
  },
  watch: {
    C_files: {
      handler() {
        this.$_emitValue();
      },
      deep: true,
    },
  },
  methods: {
    $_emitValue() {
      this.$emit("input", this.C_files.url);
    },
    $_onFileRemove() {
      this.C_files.url = "";
      this.$_emitValue()
    },
    $_valueSet() {
      if (this.value) {
        this.C_files = {
          url: this.value,
        };
      }
    },
    $_handleUploadProgress(progressEvent, target) {
      target.percent = Math.round(
        (progressEvent.loaded / progressEvent.total) * 100
      );
    },
    $_onRemoveClick() {
      this.$emit("input", "");
    },
    async $_onChange($event) {
      const files = $event.target.files;
      this.C_files = {
        percent: 0,
        loading: true,
        file: files[0],
        uploading: true,
      };
      if (!this.C_files.uploading) {
        return;
      }
      const file = this.C_files.file;
      if (this.accept) {
        const formData = new FormData()
        formData.append("file", file)
        this.C_files.url = file.name
        this.C_files.percent = 100;
        this.C_files.loading = false;
        this.$emit('import-file', formData)
        $event.target.value=''
      } else {
        try {
          const res = await this.$axios.put(`${this.uploadUrl}${file.name}`, file, {
            onUploadProgress: (progressEvent) =>
              this.$_handleUploadProgress(progressEvent, this.C_files),
          })
          this.C_files.url = res.data.signed_url;
          this.C_files.percent = 0;
          this.C_files.loading = false;
        } catch(error) {
          alert(error)
        }
      }
    },
    $_onClick() {
      this.$refs.fileInput.click();
    },
  },
};
</script>
<style lang="scss">
@import "../assets/scss/ws-state-file.scss";
</style>